import {useTranslation} from 'react-i18next';
import StatusLabel from '../../StatusLabel/StatusLabel';
import {TMemberSubscription} from '../memberTicket.type';
import {subscriptionStatusConfig} from '../memberTicket.utils';

interface MemberTicketStatusProps {
    subscription: TMemberSubscription;
}

/* The status bar above the subscription card — active / expired / redeemed / canceled */
function MemberTicketStatus({subscription}: MemberTicketStatusProps) {
    const {t} = useTranslation('eTicket');
    const {color, textKey} = subscriptionStatusConfig[subscription.status];

    return <StatusLabel color={color} text={t(textKey)} data-cy="member-ticket-status" />;
}

export default MemberTicketStatus;
